'use client';

import { type LayoutNode, type LayoutNodeStyleMap } from 'shop-ui/types';
import { ELEMENT_TYPE, FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import i18n from '@shared/i18n';

export const componentName = 'Logo';

export enum OFFICIAL_LOGO_KEY {
    LOGO = 'official-site-logo',
}

export const showCutList = [
    {
        key: OFFICIAL_LOGO_KEY.LOGO,
        type: ELEMENT_TYPE.LOGO,
        content: i18n.gettext('Logo'),
        version: 1,
    },
];

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.LOGO,
    name: componentName,
    enable: true,
    next: null,
    deletable: false,
};

export const features = [FEATURE_FLAG_KEYS.RESIZE_HANDLE, FEATURE_FLAG_KEYS.IMAGE_URL];

const defaultStyle = {
    [FEATURE_FLAG_KEYS.READONLY_DEFAULT_IMAGE_URL]:
        '/static/page-editor-logo-component-default_v1.png',
} as const;

export function createLogo(
    presetStyle?: LayoutNodeStyleMap[string],
    options?: Partial<LayoutNode>
) {
    const id = getElementUlId();

    const layout = {
        ...config,
        ...(options || {}),
        id,
    };

    return {
        id,
        layout,
        style: {
            ...defaultStyle,
            ...presetStyle,
        },
    };
}

export function generate(
    sectionName: string = i18n.gettext('區塊'),
    options?: { shouldWrap?: boolean }
) {
    const media = createLogo();

    const shouldWrap = options?.shouldWrap ?? true;

    return combineComponent(sectionName, [media], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        shouldWrap,
    });
}
